module.exports = __webpack_public_path__ + "img/equipment_1.f0eec84b.jpg";